export const LOT = 'Lot';
//# sourceMappingURL=lot.js.map